import React, { Component } from 'react'
import { Box, CustomizedErrorMessage } from '../../styles.style'
import { getIn } from 'formik'
import { ClientService } from '../../../../services/client.service'

class DocumentRG extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rgError: '',
			validating: false
		}
	}

	nextPage = () => {
		const { showLoading, hideLoading, providerSignupData, handleSetRg, nextStep, toastError } = this.props
		const rg = this.props.values.rg

		if (!rg) {
			this.setState({ rgError: 'Informe o RG' })
			return
		}

		this.setState({ validating: true })
		showLoading()

		const obj = { rg, email: providerSignupData.email }

		ClientService.checkExistingRGDocument(obj)
			.then(data => {
				if (!data.success) {
					this.setState({
						rgError: 'Já existe um usuário cadastrado com o RG informado',
						validating: false
					})
					hideLoading()
					return
				}
				handleSetRg(rg)
				this.setState({ validating: false })
				hideLoading()
				nextStep()
			})
			.catch(() => {
				this.setState({ validating: false })
				toastError({
					message: 'Não foi possível validar o RG informado.'
				})
				hideLoading()
			})
	}

	render() {
		const {
			handleBlur,
			handleChange,
			values,
			errors,
			touched,
			prevStep
		} = this.props

		const { rgError, validating } = this.state
		const isNextDisabled = !values.rg || values.rg.length < 5 || validating

		return (
			<Box>
				<div className="field">
					<header>
						<h5>Ok, precisamos do seu RG</h5>
					</header>

					<div>
						<input
							className={
								getIn(errors, 'rg') && getIn(touched, 'rg')
									? 'field-error input-big'
									: 'input-big'
							}
							type="text"
							placeholder="RG"
							id="rg"
							name="rg"
							maxLength={14}
							value={values.rg}
							onChange={e => {
								this.setState({ rgError: '' })
								handleChange(e)
							}}
							onBlur={handleBlur}
						/>
						{rgError && (
							<CustomizedErrorMessage>{rgError}</CustomizedErrorMessage>
						)}
					</div>
				</div>

				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => prevStep()}>
						Voltar
					</button>
					<button
						disabled={isNextDisabled}
						className={isNextDisabled ? 'disabled button' : 'button'}
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default DocumentRG
